// extracted by mini-css-extract-plugin
module.exports = {"container":"AddMember_container__3KxFo","upper":"AddMember_upper__Pw6X0","lower":"AddMember_lower__3D_aA","strong":"AddMember_strong__3UYYY","heading":"AddMember_heading__3fdlt"};